import { Link } from 'react-router';
import { useSession } from '../lib/session';
import { Alert, Card, PageHeader } from '../components/ui';

const PROFILES = [
  {
    name: 'Monitoramento',
    does: 'Inventário do aparelho, versão do Android, estado do agente e último contato. Localização só com consentimento.',
    doesNot: 'Não bloqueia apps nem impede a desinstalação.',
  },
  {
    name: 'Controle Assistido',
    does: 'Launcher com apps autorizados, senha para sair do launcher e filtro de domínios por VPN com consentimento.',
    doesNot:
      'Não impede desinstalação, modo seguro nem acesso às configurações. O usuário pode desligar a VPN.',
  },
  {
    name: 'Controle Corporativo',
    does: 'Aparelho provisionado oficialmente (Android Enterprise, Device Owner): allowlist, kiosk e restrições do sistema.',
    doesNot:
      'Exige aparelho novo ou restaurado. Não se aplica a um app instalado depois da configuração inicial.',
  },
];

export function HomePage() {
  const { me, tenant, tenants } = useSession();
  const firstName = me?.user.name.split(' ')[0] ?? '';

  return (
    <>
      <PageHeader
        title={`Olá, ${firstName}`}
        description={
          tenant
            ? `Você está gerenciando ${tenant.name}.`
            : 'Selecione uma empresa no topo da página para começar.'
        }
      />
      <div className="space-y-6">
        {me?.user.isSuperadmin && tenants.length === 0 && (
          <Alert tone="info">
            Nenhuma empresa cadastrada ainda.{' '}
            <Link to="/empresas" className="font-medium underline">
              Cadastre a primeira empresa
            </Link>
            .
          </Alert>
        )}
        {me && me.user.mfaEnabled && me.user.recoveryCodesRemaining <= 3 && (
          <Alert tone="warning">
            Restam {me.user.recoveryCodesRemaining} códigos de recuperação de MFA.{' '}
            <Link to="/conta" className="font-medium underline">
              Gere novos códigos
            </Link>
            .
          </Alert>
        )}
        <Card title="Perfis do agente Android">
          <p className="mb-4 text-sm text-slate-600">
            Um único aplicativo opera no perfil que o aparelho realmente permite. O painel sempre
            mostra o perfil solicitado e o perfil efetivamente aplicado.
          </p>
          <div className="grid gap-4 md:grid-cols-3">
            {PROFILES.map((p) => (
              <div key={p.name} className="rounded-md border border-slate-200 p-3">
                <h3 className="text-sm font-semibold text-slate-900">{p.name}</h3>
                <p className="mt-2 text-sm text-slate-700">{p.does}</p>
                <p className="mt-2 text-xs text-slate-500">
                  <span className="font-medium">Limite: </span>
                  {p.doesNot}
                </p>
              </div>
            ))}
          </div>
        </Card>
        <Card title="Próximas etapas da plataforma">
          <p className="text-sm text-slate-600">
            Pareamento de dispositivos, inventário e heartbeat estão em desenvolvimento (Fase 2).
            Por enquanto, cadastre empresas, usuários e grupos.
          </p>
        </Card>
      </div>
    </>
  );
}
